<div class="barra"></div>
<div class="footer ">
  <div align="right">
    {{version}}
  </div>
</div>
